import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';

import { Row, T8y } from 'ui';

import { ReactComponent as BlackSmallArrow } from 'assets/images/icons/blackSmallArrow.svg';

import style from './faqSectionWrapper.module.scss';

export const FaqSectionWrapper = ({ header, answer, product }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenFaqAnswer = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  useEffect(() => {
    setIsOpen(false);
  }, [product]);

  return (
    <Row
      className={clsx(style.faqWrapper, isOpen && style.open)}
      direction="column"
      fullWidth
    >
      <button
        data-testid="openFaqAnswer-btn"
        type="button"
        onClick={handleOpenFaqAnswer}
        className={style.faqOpenButton}
      >
        <Row
          className={clsx(
            style.blockHeaderWrapper,
            isOpen && style.openBlockHeaderWrapper,
          )}
          noWrap
          direction="column"
        >
          <Row
            justify="stretch"
            align="center"
            noWrap
            fullWidth
            className={clsx(style.question, isOpen && style.openedTitle)}
          >
            <T8y variant="t1v1" xsVariant="t2v1" bold>
              {header}
            </T8y>
            <Row className={style.arrowWrapper} justify="center" align="center">
              <BlackSmallArrow as={Row} />
            </Row>
          </Row>
          {isOpen && (
            <T8y
              variant="t1v1"
              xsVariant="t2v1"
              color="mainGray"
              className={style.answer}
            >
              {answer}
            </T8y>
          )}
        </Row>
      </button>
    </Row>
  );
};
